import React from 'react'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import { useTranslation } from 'react-i18next'
import { TableHeader, DataMessage } from '..'
import CouponTableRow from './CouponTableRow'
import { makeStyles } from '@material-ui/core/styles'
import { useStore } from '../../Models/RootStore'

const useStyles = makeStyles((theme) => ({
	root: {
		maxWidth: 1400
	},
	smallSpacer: {
		height: '0.25rem'
	},
	spacer: {
		height: '1rem'
	}
}))

function CouponTable(props) {
	const classes = useStyles()
	const { t } = useTranslation()

	const { sessionStore } = useStore()

	const filteredItems = sessionStore.user.role === 'admin' ? props.items : props.items?.filter((item) => item.creatorId === sessionStore.user.id) || []

	const renderRows = () => {
		if (filteredItems.length > 0) {
			return filteredItems.map((item) => (
				<React.Fragment key={item.id}>
					<div className={classes.spacer} />
					<CouponTableRow item={item} />
				</React.Fragment>
			))
		}
		return null
	}

	return (
		<>
			<Table classes={{ root: classes.root }}>
				<TableHeader columnNames={[t('name'), t('number_of_uses'), t('category'), t('organization'), t('validity')]} />
				<div className={classes.smallSpacer} />
				<TableBody>{renderRows()}</TableBody>
			</Table>
			<DataMessage data={props.items} message={t('no_coupons')} />
		</>
	)
}

export default CouponTable
